import { render, staticRenderFns } from "./RedirectDetail.vue?vue&type=template&id=669e5d69&"
import script from "./RedirectDetail.vue?vue&type=script&lang=js&"
export * from "./RedirectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports